import Intro from './_intro';
import Announce2nd from './_announce2nd';

export default class Main {
    constructor() {
        this.intro = new Intro();
        this.announce2nd = new Announce2nd();

        this._init();
    }

    _init() {
        this._registerEvent();
    }

    _registerEvent() {
        window.addEventListener('load', () => {
            this.intro.execLoop();

            const announce = document.getElementById('announce2nd__modal');
            if (announce) {
                setTimeout(() => {
                    announce.classList.add('-active');
                    document.body.classList.add('-lock');
                    this.announce2nd.startAnimation();
                }, 1900);
            }
        });
    }
}
